/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlZeroDayAlertEscalationStatus = {
    ToDo: 'to_do',
    Contacted: 'contacted',
    Fixed: 'fixed',
    Ignored: 'ignored',
    FalsePositive: 'false_positive'
} as const;
export type ControlZeroDayAlertEscalationStatus = typeof ControlZeroDayAlertEscalationStatus[keyof typeof ControlZeroDayAlertEscalationStatus];


export function ControlZeroDayAlertEscalationStatusFromJSON(json: any): ControlZeroDayAlertEscalationStatus {
    return ControlZeroDayAlertEscalationStatusFromJSONTyped(json, false);
}

export function ControlZeroDayAlertEscalationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertEscalationStatus {
    return json as ControlZeroDayAlertEscalationStatus;
}

export function ControlZeroDayAlertEscalationStatusToJSON(value?: ControlZeroDayAlertEscalationStatus | null): any {
    return value as any;
}

